import { DateTime } from 'luxon'
import { ITimeAndCityLocalizable } from './ITimeAndCityLocalizable'
import { RegularRepresentationTypes, Representation } from './Representation'
import { TimeStep } from './TimeStep'

export class TimeStepValue extends TimeStep {
  constructor(
    snapshot: ITimeAndCityLocalizable,
    timestamp: DateTime,
    readonly maxFloodLevel: number,
    readonly maxIntensity: number,
    readonly maxRisk: number,
    readonly maxRt: number,
    readonly maxTa: number,
  ) {
    super(snapshot, timestamp)
  }

  getValue(representation: Representation<RegularRepresentationTypes>, pickMaxTa = false): number {
    switch (representation.type) {
      case 'flood depth':
        return this.maxFloodLevel
      case 'flood risk':
        return this.maxRisk
      case 'rainfall':
        return this.maxIntensity
      case 'return period':
        return pickMaxTa ? this.maxTa : this.maxRt
      default:
        return 0
    }
  }

  public isEmpty(): boolean {
    // console.log(this.maxRt)
    // console.log(this.maxRisk)
    // console.log(this.maxIntensity)
    // console.log(this.maxFloodLevel)
    // console.log(this.maxTa)
    return this.maxRt <= 0 && this.maxRisk <= 0 && this.maxIntensity <= 0 && this.maxFloodLevel <= 0
  }
}
